export default {
  TEAM_PERSON_VIEW: 'TEAM_PERSON_VIEW',
  LIGHTBOX: 'LIGHTBOX',
  CONTACT: 'CONTACT',
  WORK_IN_PROGRESS: 'WORK_IN_PROGRESS',
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  RESET_PASSWORD: 'RESET_PASSWORD',
};
